module.exports = __webpack_public_path__ + "static/media/mausam - heat wave.440cce81.png";